export default __webpack_public_path__ + "images/icons/softcom-logo-light.svg";